import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import mainContext from "../context/mainContext";
import { getregistertokenApi } from "../services/authApi";
import { getBoxesListApi } from "../services/leitnerApi";
import { checkErrorMessage, checkResponseData } from "../utils/utilsFunctions";

export default function OAuthGmail() {
  const nav = useNavigate();
  const [searchParams] = useSearchParams();
  const { handleUserType, handleIsAuthed } = useContext(mainContext);
  const [status, setStatus] = useState("processing");

  useEffect(() => {
    const rtoken = searchParams.get("rtoken");
    if (!rtoken) {
      setStatus("error");
      toast.error("توکن بازگشتی یافت نشد");
      setTimeout(() => nav("/login"), 2000);
      return;
    }
    getregistertokenApi({ rtoken })
      .then(async (response) => {
        const resData = checkResponseData(response);
        if (resData["success"]) {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("refreshToken", response.data.refreshToken);
          handleUserType(resData["data"]["data"][0]["type_user"]);
          handleIsAuthed(true);
          setStatus("success");
          toast.success("ورود با گوگل موفقیت‌آمیز");
          try {
            const boxRes = await getBoxesListApi({});
            if (boxRes.data?.success) {
              nav("/home");
              return;
            }
          } catch {}
          nav("/home");
        } else {
          setStatus("error");
          toast.error(response.data?.message || "خطا در ورود با گوگل");
          setTimeout(() => nav("/login"), 2000);
        }
      })
      .catch((error) => {
        const errData = checkErrorMessage(error);
        setStatus("error");
        toast.error(errData["message"] || "خطا در ورود با گوگل");
        setTimeout(() => nav("/login"), 2000);
      });
  }, []);

  return (
    <div className="container" style={{ maxWidth: 440, textAlign: "center", paddingTop: 80 }}>
      {status === "processing" && (
        <div>
          <div className="spinner" style={{ margin: "0 auto 1rem" }}></div>
          <p style={{ color: "var(--text-secondary)" }}>در حال ورود با گوگل...</p>
        </div>
      )}
      {status === "success" && (
        <div>
          <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
          <p style={{ color: "var(--success)" }}>ورود موفقیت‌آمیز</p>
        </div>
      )}
      {status === "error" && (
        <div>
          <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
          <p style={{ color: "var(--danger)" }}>خطا در ورود با گوگل</p>
        </div>
      )}
    </div>
  );
}